import api from './api';
import wilayasJson from '../data/wilayas.json';

export interface WilayaDto {
    code: string;
    name: string;
}

class WilayasService {
    /**
     * Fetch all wilayas from the API.
     * Falls back to the local JSON file if the request fails.
     */
    async findAll(): Promise<WilayaDto[]> {
        try {
            const response = await api.get<WilayaDto[]>('/wilayas');
            return response.data;
        } catch (error) {
            console.warn('[WilayasService] API unavailable, falling back to local data.', error);
            return wilayasJson as WilayaDto[];
        }
    }
}

const wilayasService = new WilayasService();
export default wilayasService;
